import BaseService from "./BaseService";

const BASE = "certificates/batches";

// Without an item type (CERTIFICATE_ITEM_TYPE_ALL): both types together.
export const getCertificateItems = (itemType) =>
  BaseService.callAPI(
    itemType ? `${BASE}/items?itemType=${itemType}` : `${BASE}/items`
  );

// The tenant's cohorts (audiences) by name, [{ id, name }]: needs only report
// access, unlike the Cohort Management list.
export const getCertificateAudiences = () =>
  BaseService.callAPI(`${BASE}/audiences`);

export const previewCertificateBatch = (body) =>
  BaseService.callAPI(`${BASE}/preview`, "POST", body);

export const createCertificateBatch = (body) =>
  BaseService.callAPI(BASE, "POST", body);

// namePattern: the list's search (a chosen item's name, or All training).
export const getCertificateBatches = ({ pageNo, pageSize, namePattern }) =>
  BaseService.callAPI(
    `${BASE}?${new URLSearchParams({
      pageNo,
      pageSize,
      ...(namePattern ? { namePattern } : {}),
    })}`
  );

export const getCertificateBatch = (id) => BaseService.callAPI(`${BASE}/${id}`);

export const downloadCertificateBatch = (id) =>
  BaseService.callAPI(`${BASE}/${id}/download`, "GET", null, {
    responseType: "blob",
  });
